export default function isTeamLead(entity, personId) {
  return entity?.lead_uuid === personId;
}
